'use client';
import Link from 'next/link';
// TODO - replace image imports with Contentful media
import logoImg from '../../../public/images/collinson-logo.png';
import CustomImage from '../CustomImage/CustomImage';

export const HeaderLogo = ({
    className = '',
    link,
    forcePageRefresh = false,
    closeHamburger,
}: {
    className?: string;
    link: string;
    forcePageRefresh?: boolean;
    closeHamburger?: () => void;
}) => {
    const LinkComponent = forcePageRefresh ? 'a' : Link;
    return (
        <div
            className={className}
            onClick={() => {
                if (closeHamburger) closeHamburger();
                window.dataLayer && window.dataLayer.push({ event: 'cta_click', cta_type: 'logo' });
                window.dataLayer && window.dataLayer.push({ event: 'logo_link_click' });
            }}
        >
            <LinkComponent className="" href={link}>
                <CustomImage
                    src={logoImg}
                    priority
                    className="logo"
                    alt="Collinson"
                    width="426"
                    height="94"
                />
            </LinkComponent>
        </div>
    );
};
